import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { services } from '../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { TranslationService } from '../../../../../../shared/services/translations.service';

@Component({
  selector: 'app-lol-masteries',
  templateUrl: './lol-masteries.component.html'
})
export class LolMasteriesComponent {
  service = 'masteries';
  availableServices = services['lol'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'lol',
    service: 'masteries',
    type: 'solo',
    title: {
      en: 'Champion Mastery',
      fr: 'Maitrise de champion'
    },
    subtitle: {
      en: 'Guaranteed Mastery Level on a Champion, with the Booster playing in your account',
      fr: 'Niveau de maîtrise garanti pour un champion, avec le booster jouant sur votre compte',
      de: 'Garantierte Mastery Level für einen Champion, wenn der Booster auf deinem Konto gespielt wird',
      pt: "Nível de Maestria Garantido em um Campeão, com o Booster jogando na sua conta",
      es: 'Nivel de maestría garantizado en un campeón, con el booster jugando en tu cuenta',
    },
    start: 5,
    desired: 10,
    serviceName: 'Masteries',
    min: 1,
    max: 10,
    champion: 'Aatrox'
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is A Mastery Level Boosting Service?",
        answer: "It is a guaranteed service that allows you to reach a predetermined mastery level on a champion you desire."
      },
      {
        question: "What If My Champion Is Banned Or Picked?",
        answer: "We can safely dodge up to two games per day, thereby accelerating the process. Further daily dodges will not benefit the account."
      },
      {
        question: "From Mastery 5 To 7, What Account Requirements Do I Need?",
        answer: "In addition to the tokens, you need 5400BE (2450BE+2950BE) or 2 Champion Shards/Permanents of the champion whose mastery level you wish to increase."
      },
      {
        question: "What If I Do not Have Enough BE To Upgrade My Mastery Level?",
        answer: "We still earn the tokens necessary for the upgrade, and once the required BE or champion shard/permanent is obtained, the upgrade can be completed."
      },
      {
        question: "In Which Game Mode Is Mastery Level Played?",
        answer: "Mastery Level boosting can be played in Blind Queue and Draft Queue."
      },
      {
        question: "Can I Request The Same Booster For A Future Purchase?",
        answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un service de boosting de niveau de maîtrise?",
        answer: "Il s\'agit d\'un service garanti qui vous permet d\'atteindre un niveau de maîtrise prédéterminé pour un champion que vous souhaitez."
      },
      {
        question: "Que se passe-t-il si mon champion est banni ou déjà choisi?",
        answer: "Nous pouvons esquiver en toute sécurité jusqu\'à deux parties par jour, ce qui accélère le processus. Plus d\'esquives quotidiennes ne seront pas bénéfiques pour le compte."
      },
      {
        question: "De la maîtrise 5 à la maîtrise 7, quelles sont les exigences de compte dont j\'ai besoin?",
        answer: "En plus des jetons, vous avez besoin de 5400BE (2450BE+2950BE) ou de 2 fragments de Champion /Champions Permanents pour le champion dont vous souhaitez augmenter le niveau de maîtrise."
      },
      {
        question: "Que se passe-t-il si je n\'ai pas assez de BE pour augmenter mon niveau de maîtrise?",
        answer: "Nous continuons à gagner les jetons nécessaires à la montée en grade, et une fois que le BE ou le fragment de champion/champion permanent requis est obtenu, la montée de niveau peut être achevée."
      },
      {
        question: "Dans quel mode de jeu le boosting de niveau de maîtrise est-il joué?",
        answer: "Le boosting du niveau de maîtrise peut être joué en mode aveugle et en mode draft."
      },
      {
        question: "Puis-je demander le même booster pour un prochain achat?",
        answer: "Oui ! Cliquez sur l\'icône en forme de cœur dans le tableau de bord de commande pour ajouter un booster en favori, puis réassignez-le facilement à vos prochaines commandes."
      }
    ],
    de: [
      {
        question: "Was ist ein Mastery Level Boosting Service?",
        answer: "Es ist ein garantierter Service, der es dir ermöglicht, eine vorher festgelegte Meisterschaftsstufe auf einem Champion deiner Wahl zu erreichen."
      },
      {
        question: "Was passiert, wenn mein Champion gesperrt oder ausgewählt wird?",
        answer: "Um den Prozess zu beschleunigen, können wir sicher bis zu zwei Spiele pro Tag vermeiden. Es ist für das Konto nicht von Vorteil, täglich mehr Spiele zu vermeiden."
      },
      {
        question: "Von Mastery 5 bis 7, welche Kontoanforderungen brauche ich?",
        answer: "Zusätzlich zu den Token benötigst du 5400BE (2450BE+2950BE) oder 2 Camhpion Shards/Permanents, dessen Meisterschaftsstufe du erhöhen möchtest."
      },
      {
        question: "Was ist, wenn ich nicht genug BE habe, um mein Mastery Level zu erhöhen?",
        answer: "Wir verdienen immer noch die Token, die wir für das Upgrade benötigen. Sobald wir die erforderlichen BE oder Champion Shard/Permanent erhalten haben, können wir das Upgrade abschließen."
      },
      {
        question: "In welchem Spielmodus wird die Mastery Level gespielt?",
        answer: "Mastery Level Boosting kann in Blind Queue und Draft Queue gespielt werden."
      },
      {
        question: "Kann ich denselben Booster auch für einen späteren Kauf anfordern?",
        answer: "Ja! Klicke im Bestell-Dashboard auf das Herzsymbol, um einen Booster zu deinen Favoriten hinzuzufügen, und weise ihn dann ganz einfach zukünftigen Bestellungen zu."
      }
    ],
    pt: [
      {
        question: "O que é um serviço de aumento de nível de maestria?",
        answer: "É um serviço garantido que permite atingir um nível de maestria predeterminado em um campeão que você deseja."
      },
      {
        question: "O que acontece se meu campeão for banido ou escolhido?",
        answer: "Podemos esquivar com segurança até dois jogos por dia, acelerando assim o processo. Esquivas diárias adicionais não beneficiarão a conta."
      },
      {
        question: "De Maestria 5 a 7, quais são os requisitos da conta?",
        answer: "Além dos tokens, você precisa de 5400BE (2450BE+2950BE) ou 2 Fragmentos/Permanentes do campeão cujo nível de maestria você deseja aumentar."
      },
      {
        question: "O que acontece se eu não tiver BE suficiente para melhorar meu nível de maestria?",
        answer: "Ainda ganhamos os tokens necessários para a atualização, e uma vez que o BE necessário ou o fragmento/permanente do campeão seja obtido, a atualização pode ser concluída."
      },
      {
        question: "Em qual modo de jogo é jogado o nível de maestria?",
        answer: "O aumento do nível de maestria pode ser jogado na fila cega e na fila de escolha."
      },
      {
        question: "Posso Escolher O Mesmo Booster Para Uma Compra Futura?",
        answer: "Sim! Clica no ícone de coração dentro do painel do pedido para marcar um booster como favorito e depois escolhe-o facilmente nos teus próximos pedidos."
      }
    ],
    es: [
      {
        question: "¿Qué es un servicio de Boost de nivel de maestría?",
        answer: "Es un servicio garantizado que te permite alcanzar un nivel de maestría predeterminado en un campeón que desees."
      },
      {
        question: "¿Qué pasa si mi campeón es vetado o elegido?",
        answer: "Podemos esquivar con seguridad hasta dos partidos al día, acelerando así el proceso. Más esquivas diarias no beneficiarán a la cuenta."
      },
      {
        question: "De la Maestría 5 a la 7, ¿qué requisitos de cuenta necesito?",
        answer: "Además de las fichas, necesitas 5400BE (2450BE+2950BE) o 2 esquirlas/permanentes de campeón del campeón cuyo nivel de maestría desees aumentar."
      },
      {
        question: "¿Qué pasa si no tengo suficiente BE para subir mi nivel de maestría?",
        answer: "Seguimos ganando las fichas necesarias para la mejora y, una vez obtenido el BE o el fragmento/permanente de campeón necesario, se puede completar la mejora."
      },
      {
        question: "¿En qué modo de juego se juega al Nivel de Maestría?",
        answer: "El Boost de Nivel de Maestría se puede jugar en Blind Queue y Draft Queue."
      },
      {
        question: "¿Puedo solicitar el mismo booster para una futura compra?",
        answer: "¡Sí! Haz clic en el ícono de corazón dentro del panel del pedido para añadir un booster a favoritos y así poder reasignarlo fácilmente en tus futuros pedidos."
      }
    ]
  }

  private page = {
    title: {
      en: "LoL Boost - Mastery Level Boosting for League of Legends",
      fr: "Boost LoL - Boosting de niveau de maîtrise sur League of Legends",
      de: "LoL Boost - Mastery Level Boosting für League of Legends",
      pt: "LoL Boost - Aumento do Nível de Maestria para League of Legends",
      es: "LoL Boost - Boosting de nivel de maestría para League of Legends",
    },
    metaDescription: {
      en: "Looking to improve your normal game MMR in League of Legends? Our affordable, fast, and secure service will help you queue against better players!",
      fr: "Vous cherchez à améliorer votre MMR en mode normal sur League of Legends ? Notre service abordable, rapide et sécurisé vous permettra d\'affronter de meilleurs joueurs!",
      de: "Du möchtest deine MMR verbessern, indem du dich mit anderen Spielern in League of Legends triffst? Wir helfen dir dabei, dich mit besseren Spielern zu messen - kostengünstig, schnell und sicher!",
      pt: "Quer melhorar seu MMR em jogos normais no League of Legends? Nosso serviço acessível, rápido e seguro vai ajudá-lo a enfrentar jogadores melhores!",
      es: "¿Quieres mejorar tu MMR de juego normal en League of Legends? ¡Nuestro servicio asequible, rápido y seguro te ayudará a hacer cola contra mejores jugadores!",
    }
  }

  private lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private cookie: CookieService, private translationService: TranslationService,) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }
    });

    title.setTitle(this.page.title[this.lang] || this.page.title['en']);
    meta.updateTag(
      {
        name: 'description',
        content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
      }
    );
  }
}